// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import OverlayTrigger from '../../components/Overlay/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';

type Props = {
    id: string,
    styles: any,
};

export default class WhyCantRetractBidPopover extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const { id, styles } = this.props;
        const whyCantRetractBidPopover = (
            <Popover id={id} bsClass={`${styles['why-cant-i-retract-bid-popover-text']} popover`}>
                <FormattedMessage id="why_cant_i_retract_bid_popover_text" />
            </Popover>
        );
        const whyCantRetractBidOverlay = (
            <OverlayTrigger trigger={['click']} placement="top" overlay={whyCantRetractBidPopover} rootClose>
                <a role="button" tabIndex="0">
                    <FormattedMessage id="retract" />
                </a>
            </OverlayTrigger>
        );
        return whyCantRetractBidOverlay;
    }
}
